import type { FC, HTMLAttributes, ReactNode } from "react";

import { DiscountDisclaimer } from "@checkout/components/DiscountDisclaimer";
import { useDiscountDisclaimer } from "@checkout/hooks/useDiscountDisclaimer";

import styles from "./AsideLayout.module.scss";

type AsideLayoutProps = {
  slot0?: ReactNode;
  slot1?: ReactNode;
  slot2?: ReactNode;
  slot3?: ReactNode;
  slot4?: ReactNode;
  slot5?: ReactNode;
  slot6?: ReactNode;
  referralCodeSlot?: ReactNode;
  paymentSummarySlot?: ReactNode;
} & HTMLAttributes<HTMLDivElement>;

export const AsideLayout: FC<AsideLayoutProps> = ({
  slot0,
  slot1,
  slot2,
  slot3,
  slot4,
  slot5,
  slot6,
  referralCodeSlot,
  paymentSummarySlot,
  ...restProps
}) => {
  const { disclaimerMessage, warningMessage } = useDiscountDisclaimer();

  return (
    <div className={styles.container} {...restProps}>
      <DiscountDisclaimer disclaimerMessage={disclaimerMessage} warningMessage={warningMessage} />

      {/* Items summary */}
      {slot3 && (
        <div className={styles.slot3} data-testid="itemsSummary">
          {slot3}
        </div>
      )}

      {slot6}

      {/* Payment summary */}
      {paymentSummarySlot}

      {/* Subscription Summary before PromoCode */}
      {slot0 && (
        <div className={styles.slot0} data-testid="subscriptionSummary0">
          {slot0}
        </div>
      )}

      {referralCodeSlot && <div data-testid="referralCode">{referralCodeSlot}</div>}

      {/* Promo code */}
      {slot1 && (
        <div className={styles.slot1} data-testid="promoCode">
          {slot1}
        </div>
      )}
      {/* PointsBlock */}
      {slot4 && (
        <div className={styles.slot4} data-testid="loyaltyPoints">
          {slot4}
        </div>
      )}
      {/* Subscription Summary */}
      {slot5 && (
        <div className={styles.slot5} data-testid="subscriptionSummary5">
          {slot5}
        </div>
      )}
      {/* CheckoutView button */}
      {slot2 && (
        <div className={styles.slot2} data-testid="checkoutButton">
          {slot2}
        </div>
      )}
    </div>
  );
};
